/* eslint-disable @typescript-eslint/no-unused-vars */
import { AhorrosMockProvider } from './AhorrosMockProvider';
import { MocksHelper } from './MocksHelper';

const ahorrosProvider = new AhorrosMockProvider();
const AhorrosMockService = {
  retrieveAhorrosInfo: (input: any) => {
    const data = ahorrosProvider.getAhorrosResponse();
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
  retrieveAhorrosTicketTotalInfo: () => {
    const data = ahorrosProvider.getAhorrosResponse();
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
  retrieveAhorrosTableInfo: (input: any) => {
    const fecha = Number(input.periodo);
    const data = ahorrosProvider.getAhorrosResponseByDates(fecha);
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
};
export default AhorrosMockService;
